export default "__VITE_ASSET__CPZM8ggy__"